const isAuthenticated = (state = false, action) => {
  switch (action.type) {
    case 'FETCH_CREDENTIALS_SUCCESS':
      if (action.data) {
        return action.data.isAuthenticated
      }
      return false
    default:
      return state
  }
}

export default isAuthenticated
